import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';

import { Desktop } from '../Common/const';

class StudyCounters extends React.Component {
  render() {
    let counters;

    if (!this.props.comingSoon && !this.props.deletedItem) {
      if (
        this.props.reviewWhen ||
        (this.props.review == 0 &&
          this.props.new == 0 &&
          this.props.learning == 0)
      ) {
        counters = !this.props.reviewWhen ? (
          <div className="study-counter ml-0">
            <em>Review Again Later</em>
          </div>
        ) : (
          <div className="study-counter ml-0">
            <em>{this.props.reviewWhen}</em>
          </div>
        );
      } else {
        counters = (
          <div className="study-counter ml-0 d-flex flex-row">
            <span className="learn" id={`learn${this.props.id}`}>
              {this.props.learning}
            </span>
            <Desktop>
              <UncontrolledTooltip
                placement="top"
                target={`learn${this.props.id}`}
              >
                Learning
              </UncontrolledTooltip>
            </Desktop>

            <span className="review" id={`review${this.props.id}`}>
              {this.props.review}
            </span>
            <Desktop>
              <UncontrolledTooltip
                placement="top"
                target={`review${this.props.id}`}
              >
                Review Today
              </UncontrolledTooltip>
            </Desktop>
            <span className="new" id={`new${this.props.id}`}>
              {this.props.new}
            </span>
            <Desktop>
              <UncontrolledTooltip
                placement="top"
                target={`new${this.props.id}`}
              >
                New
              </UncontrolledTooltip>
            </Desktop>
          </div>
        );
      }
    } else {
      counters = (
        <div className="study-counter ml-0">
          <em>Under development</em>
        </div>
      );
    }

    return counters;
  }
}

export default StudyCounters;
